import { useState } from 'react';
import './SolutionsRange.css';

import logoAlpha   from '../../assets/brand_alphaess.svg';
import logoSofar   from '../../assets/brand_sofar.svg';
import logoGrowatt from '../../assets/brand_growatt.png';
import logoSolax   from '../../assets/brand_solax.png';
import logoSungrow from '../../assets/brand_sungrow.svg';
import logoRisen  from '../../assets/brand_risen_logo.png';

import imgScene   from '../../assets/figma_sol_battery.jpg';
import imgAlpha   from '../../assets/sb_alpha_house.png';
import imgSofarInstall from '../../assets/sb_sofar_house.png';
import imgSolaxInstall from '../../assets/sb_solax_house.png';
import imgGrowatt from '../../assets/sb_growatt_house.png';
import imgSungrow from '../../assets/sb_sungrow_house.png';
import imgRisen   from '../../assets/risen_install.png';

const brands = [
  {
    id: 'growatt',
    tabLogo: logoGrowatt, tabName: 'Growatt',
    brandLabel: 'GROWATT', productName: 'ALP',
    img: imgGrowatt,
    desc: 'Modular and scalable home battery system with industry-leading safety standards.',
    features: ['Modular Design', 'Scalable Capacity', 'Single & Three-Phase', 'Smart Energy Management', 'IP66 Rated'],
    url: 'https://au.growatt.com/',
  },
  {
    id: 'alphaess',
    tabLogo: logoAlpha, tabName: 'Alpha ESS',
    brandLabel: 'ALPHA ESS', productName: 'SMILE-G3-S5',
    img: imgAlpha,
    desc: 'Intelligent all-in-one energy storage system designed for Australian homes.',
    features: ['All-in-One Design', 'Backup Power Ready', 'Single & Three-Phase', 'VPP Compatible', 'IP65 Rated'],
    url: 'https://www.alphaess.com/',
  },
  {
    id: 'sofar',
    tabLogo: logoSofar, tabName: 'SOFAR',
    brandLabel: 'SOFAR SOLAR', productName: 'PowerAll HYD',
    img: imgSofarInstall,
    desc: 'All-in-one hybrid inverter and battery system built for Australian residential use.',
    features: ['Hybrid Inverter + Battery', 'Seamless Backup Mode', 'Three-Phase Option', 'Smart App Control', 'IP65 Rated'],
    url: 'https://www.sofarsolar.com/solution/residentialstorage.html',
  },
  {
    id: 'solax',
    tabLogo: logoSolax, tabName: 'SolaX',
    brandLabel: 'SOLAX POWER', productName: 'X-Hybrid G4',
    img: imgSolaxInstall,
    desc: 'High-voltage smart hybrid storage with seamless auto backup for Australian homes.',
    features: ['High-Voltage System', 'Auto Backup Mode', 'Three-Phase Ready', 'VPP Ready', 'IP66 Rated'],
    url: 'https://www.solaxpower.com/',
  },
  {
    id: 'sungrow',
    tabLogo: logoSungrow, tabName: 'Sungrow',
    brandLabel: 'SUNGROW', productName: 'SBR Home Battery',
    img: imgSungrow,
    desc: 'Lithium iron phosphate modular battery with flexible installation for Australian homes.',
    features: ['LFP Battery Chemistry', 'Modular & Scalable', 'Single & Three-Phase', 'VPP Compatible', 'IP55 Rated'],
    url: 'https://www.sungrowpower.com/au/en',
  },
  {
    id: 'risen',
    tabLogo: logoRisen, tabName: 'RISEN ENERGY',
    brandLabel: 'RISEN ENERGY', productName: 'N-Type Dual Glass Modules',
    img: imgRisen,
    desc: 'Risen N-Type Dual Glass Modules — built for long-term performance and backed by industry-leading warranties.',
    features: ['15-Year Product Warranty', '30-Year Linear Power Warranty', 'First-Year Degradation ≤ 1%', 'Annual Degradation ≤ 0.4%', '87.4% Output Guaranteed After 30 Years'],
    url: 'https://risenenergy.com.au/',
  },
];

export default function SolutionsRange() {
  const [active, setActive] = useState(0);
  const brand = brands[active];

  return (
    <section className="sr-section">
      <div className="sr-inner">
        <div className="sr-card">

          {/* Row 1 col 1 — eyebrow + heading */}
          <div className="sr-intro-top">
            <p className="sr-eyebrow">OUR PRODUCT RANGE</p>
            <h2 className="sr-heading">Trusted Brands.<br />Premium Performance.</h2>
          </div>

          {/* Row 2 col 1 — body text; same Y as photo, white bg keeps it off the image */}
          <div className="sr-intro-body">
            <p className="sr-body">
              We only work with solar and battery brands that have been established in Australia for over 10 years — selected for reliability, long-term support, and real-world performance.
            </p>
          </div>

          {/* Row 2 col 1+2 — scene photo */}
          <div className="sr-photo">
            <img src={brand.img} alt={brand.productName} />
          </div>

          {/* Row 1 col 2+3 — brand tabs at heading level */}
          <div className="sr-tabs">
            {brands.map((b, i) => (
              <button
                key={b.id}
                className={`sr-tab ${active === i ? 'sr-tab--active' : ''}`}
                onClick={() => setActive(i)}
              >
                {b.tabLogo
                  ? <img src={b.tabLogo} alt={b.tabName} className="sr-tab-logo" />
                  : <span className="sr-tab-text">{b.tabName}</span>
                }
              </button>
            ))}
          </div>

          {/* Row 2 col 3 — product info at same level as photo and body text */}
          <div className="sr-info">
            {brand.tabLogo
              ? <img src={brand.tabLogo} alt={brand.brandLabel} className="sr-info-logo" />
              : <p className="sr-info-logo-text">{brand.brandLabel}</p>
            }
            <p className="sr-product-name">{brand.productName}</p>
            <p className="sr-product-desc">{brand.desc}</p>
            <ul className="sr-features">
              {brand.features.map((f, i) => (
                <li key={i}>
                  <span className="sr-feat-icon">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="#1a6fcc" strokeWidth="2"/>
                      <path d="M8 12l3 3 5-5" stroke="#1a6fcc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  {f}
                </li>
              ))}
            </ul>
            <a href={brand.url} target="_blank" rel="noopener noreferrer" className="sr-cta-btn">
              Explore Products →
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
